<template>
    <BreadCrumb PageTitle="Historique de téléchargement" />
    <HistoriqueTelechargement />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import HistoriqueTelechargement from "../../components/Historique/HistoriqueTelechargement.vue";

  export default defineComponent({
    name: "ListeGenreHistoriqueTelechargementPage",
    components: {
      BreadCrumb,
      HistoriqueTelechargement,
    },
  });
  </script>